import type { JSX } from "react";

import { Box, Stack, Text } from "@mantine/core";

import { useSalesContext } from "../../../../sales-context/SalesContext";
import { mapPartnerToDisplayName } from "./OffersView.helpers";

export function DeviceInsights(): JSX.Element | null {
    const formatPhoneNumberDisplay = (phoneNumber: string): string => {
        if (phoneNumber.length <= 3) return `(${phoneNumber}`;
        if (phoneNumber.length <= 6) return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
    };

    const { ivrInfo, partner } = useSalesContext();
    const { productTitle, orderNumber, brandPhoneNumber, supportPhoneNumber } = ivrInfo || {};

    if (!productTitle) return null;

    return (
        <Box
            bg="dark.5"
            m="sm"
            style={{
                borderRadius: "var(--mantine-radius-md)",
                maxWidth: 360,
            }}
        >
            <Stack p="sm">
                <Stack gap="4xs">
                    <Text size="xs" c="gray.5">
                        Product
                    </Text>
                    <Text size="sm" c="gray.1">
                        {productTitle}
                    </Text>
                </Stack>

                {orderNumber ? (
                    <Stack gap="4xs">
                        <Text size="xs" c="gray.5">
                            Order number
                        </Text>
                        <Text size="sm" c="gray.1" className="fs-mask">
                            {orderNumber}
                        </Text>
                    </Stack>
                ) : null}

                {brandPhoneNumber || supportPhoneNumber ? (
                    <Stack gap="4xs">
                        <Text size="xs" c="gray.5">
                            Support phone numbers
                        </Text>
                        <Stack gap="0">
                            {brandPhoneNumber ? (
                                <Text size="sm" c="gray.1">
                                    Brand/Manufacturer: {formatPhoneNumberDisplay(brandPhoneNumber)}
                                </Text>
                            ) : null}
                            {supportPhoneNumber ? (
                                <Text size="sm" c="gray.1">
                                    {mapPartnerToDisplayName(partner)}: {formatPhoneNumberDisplay(supportPhoneNumber)}
                                </Text>
                            ) : null}
                        </Stack>
                    </Stack>
                ) : null}
            </Stack>
        </Box>
    );
}
